import { NavLink } from 'react-router-dom'
import { useResultsAvailable } from '@/hooks/useResultsAvailable'
import {
  brandLogoWhite,
  footerSocialIcons,
} from '@/components/navigation/navigationAssets'
import { getNewsRedirectUrl } from '@/lib/data/news'

const footerNavigation = [
  { label: 'Candidatos', to: '/candidatos' },
  { label: 'Referéndum y Consulta', href: 'https://www.cne.gob.ec/' },
  { label: 'Noticias', href: getNewsRedirectUrl() },
  { label: 'Resultados', to: '/resultados' },
] as const

const socialLinks = [
  {
    label: 'Facebook',
    href: 'https://www.facebook.com/diarioeltelegrafo/',
    icon: footerSocialIcons.facebook,
  },
  {
    label: 'Instagram',
    href: 'https://www.instagram.com/el_telegrafo/',
    icon: footerSocialIcons.instagram,
  },
  {
    label: 'TikTok',
    href: 'https://www.tiktok.com/@el_telegrafo',
    icon: footerSocialIcons.tiktok,
  },
  {
    label: 'YouTube',
    href: 'https://www.youtube.com/user/eltelegrafoec/',
    icon: footerSocialIcons.youtube,
  },
  {
    label: 'X',
    href: 'https://x.com/el_telegrafo',
    icon: footerSocialIcons.x,
  },
] as const

export function Footer() {
  const resultsAvailable = useResultsAvailable()
  return (
    <footer className="site-footer">
      <div className="site-footer__top">
        <a
          className="site-footer__brand"
          href="https://www.eltelegrafo.com.ec/"
          target="_blank"
          rel="noreferrer"
          aria-label="Ir a El Telégrafo"
        >
          <img src={brandLogoWhite} alt="El Telégrafo, el decano digital" />
        </a>
        <nav className="site-footer__nav" aria-label="Navegación de pie de página">
          {footerNavigation.filter((item) => !('to' in item) || item.to !== '/resultados' || resultsAvailable).map((item) =>
            'to' in item ? (
              <NavLink key={item.label} to={item.to}>
                {item.label}
              </NavLink>
            ) : (
              <a key={item.label} href={item.href} target="_blank" rel="noreferrer">
                {item.label}
              </a>
            ),
          )}
        </nav>
      </div>

      <div className="site-footer__institutional">
        <address className="site-footer__address">
          San Salvador E6-49 y Eloy Alfaro
          <br />
          Contacto: <a href="tel:+593987777778">+593 98 777 7778</a>
          <br />
          <a href="mailto:info@comunica.ec">info@comunica.ec</a>
        </address>

        <div className="site-footer__contact-links">
          <a href="mailto:info@comunica.ec">Contacto</a>
          <a href="mailto:info@comunica.ec?subject=Publicidad">Publicidad</a>
        </div>

        <div className="site-footer__legal-links">
          <a
            href="https://www.eltelegrafo.com.ec/politica-para-el-tratamiento-de-datos-personales"
            target="_blank"
            rel="noreferrer"
          >
            Política para el tratamiento de datos personales
          </a>
          <a
            href="https://www.eltelegrafo.com.ec/transparencia/codigo-deontologico"
            target="_blank"
            rel="noreferrer"
          >
            Código deontológico
          </a>
        </div>
      </div>

      <div className="site-footer__bottom">
        <div className="site-footer__social">
          <span>Síguenos en:</span>
          <div className="site-footer__social-links">
            {socialLinks.map((social) => (
              <a
                key={social.label}
                href={social.href}
                target="_blank"
                rel="noreferrer"
                aria-label={social.label}
              >
                <img src={social.icon} alt="" aria-hidden="true" />
              </a>
            ))}
          </div>
        </div>
        <small>© 2026 COMUNICA EP. Todos los derechos reservados</small>
      </div>
    </footer>
  )
}
